import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { InterviewScoringDetail } from '@/features/interview-scoring/detail'

const VIEWS = ['table', 'grid', 'brief'] as const

const searchSchema = z.object({
  view: z.enum(VIEWS).optional().catch('table'),
})

function RouteComponent() {
  const { runId } = Route.useParams()
  const { view } = Route.useSearch()
  return <InterviewScoringDetail runId={runId} view={view ?? 'table'} />
}

export const Route = createFileRoute('/_authenticated/admin/interview-scoring/$runId/')({
  validateSearch: searchSchema,
  component: RouteComponent,
})
